/* eslint-disable @next/next/no-img-element */
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { gsColors } from '../../../../styles/Variables'

const CheckboxDiv = styled.div`
  cursor: pointer;

  input[type='checkbox'] {
    display: none;
  }

  label {
    color: $revolver;
    display: block;
    font-size: 12px;
    line-height: 20px;
    padding-left: 30px;
    position: relative;

    a {
      color: ${gsColors.seance};
    }
  }

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 250ms;
    cursor: pointer;

    img {
      position: relative !important;
      width: 24px !important;
      height: 24px !important;      
    }
  }
`

const CheckboxSingle = ({
  name,
  onChange,
  textComponent: TextComponent,
  value,
  whiteUnchecked = false,
  cobaltChecked = false
}) => {
  return (
    <CheckboxDiv>
      <input
        type="checkbox"
        name={name}
        id={name}
        onChange={onChange}
        value={value}
        checked={value}
      />
      <label htmlFor={name} aria-label={name}>
        <div
          aria-label={name + '-checkbox'}
          onKeyPress={e => (e.key === 'Enter' ? onChange(e) : false)}
          role="checkbox"
          aria-checked={value}
          tabIndex={0}
          className="box"
          style={{ display: 'flex' }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {value && <img src={cobaltChecked ? '/images/checkmark_cobalt_white.svg' : '/images/checkmark_white.svg'} alt='check' />}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {
            !value ? (
              whiteUnchecked ? (
                <img src="/images/icon-unchecked-white.svg" alt="check" style={{ transform: 'scale(1.2)'}} />
              ) : (
                <img src="/images/unchecked.svg" alt="check" />
              )
            ) : null
          }
        </div>
        <TextComponent />
      </label>
    </CheckboxDiv>
  )
}

CheckboxSingle.propTypes = {
  name: PropTypes.string.isRequired,
  textComponent: PropTypes.func.isRequired
}

export default CheckboxSingle
